import React from 'react'
import AdmBookConfigurations from '../../components/AdminTabs/AdminBookConfigurations/AdmBookConfigurations'

const BookConfigurations = () => {
  return (
    <div>
        <AdmBookConfigurations/>
    </div>
  )
}

export default BookConfigurations